import React from 'react';

/**
 * Headless control element to handle the consumption of window based application session
 * into redux accessible information.
 *
 * Exposes userContext via a render function on direct children.
 */
class AuthManager extends React.Component {
    constructor(props) {
        super(props);

        // This is the current minimum used by other React modules.
        // Additional information can be collected and initialized if need in future modules.
        this.state = {
            sessionToken: null,
            role: null,
            jurisdictionId: null
        };
    }

    componentDidMount() {
        this.harvestSessionData();
    }

    harvestSessionData() {
        let userDTO = JSON.parse(sessionStorage.getItem('rckmsUserDTO'));
        let sessionToken = sessionStorage.getItem('sessionId');

        // For this use case I see just destructuring the entire UserDTO
        // and simply storing it top level along side the current user token
        let userContext = { sessionToken, ...userDTO };

        /**
         * Sentry User context
         * RCKMSDEV-62
         */

        if (typeof window.Sentry !== 'undefined') {
            window.Sentry.setUser({
                id: userContext?.userDTO?.userId || null,
                username: userContext?.userDTO?.username || null,
                email: userContext?.userDTO?.email || null,
                role: userContext?.role || null,
                jurisdiction_id: userContext?.jurisdictionId || null,
                jurisdiction_name: userContext?.jurisdictionName || null
            });
        }

        if (sessionToken) {
            this.setState({
                ...this.state,
                ...userContext
            });
        }
    }

    // TODO: Figure out how we want to handle this
    refreshSessionToken() {}

    render() {
        if (this.state.sessionToken == null) {
            // TODO: find something better to do here
            return null;
        }
        return this.props.children({
            userContext: { ...this.state }
        });
    }
}

export default AuthManager;
